export interface HomeFAQ {
  question: string;
  answer: string;
}

export const HOME_FAQS: HomeFAQ[] = [
  {
    question: "What services does Hubmicroo offer?",
    answer:
      "Hubmicroo is a full-stack software agency offering custom web and mobile app development, e-commerce solutions, UI/UX design, AI and chatbot integration, cloud architecture, and ongoing maintenance and support — everything you need to take an idea from concept to a fully launched product.",
  },
  {
    question: "How much does it cost to build a website or app with Hubmicroo?",
    answer:
      "Project cost depends on scope, features, and complexity. After a free consultation to understand your requirements, we provide a transparent, fixed-price or milestone-based quote with no hidden fees — so you know exactly what you're paying for before work begins.",
  },
  {
    question: "How long does it take to complete a project?",
    answer:
      "Most landing pages and small business websites take 1-3 weeks, while custom web apps, e-commerce platforms, and SaaS products typically take 4-12 weeks depending on complexity. We'll give you a realistic timeline with milestones during the planning phase.",
  },
  {
    question: "Do you work with clients outside Pakistan?",
    answer:
      "Yes. We work with clients worldwide, including the US, UK, Europe, and the Middle East, with offices supporting Rahim Yar Khan Pakistan. We collaborate remotely using tools like Slack, Zoom, and project management platforms to keep communication smooth across time zones.",
  },
  {
    question: "Should I choose a custom-built website or WordPress?",
    answer:
      "It depends on your goals. WordPress is great for content-heavy sites that need frequent updates by non-technical users, while a custom-built solution (Next.js, React, etc.) offers better performance, security, and scalability for businesses, e-commerce stores, and web apps. We'll recommend the best fit after understanding your needs.",
  },
  {
    question: "Can you integrate AI features or chatbots into my website?",
    answer:
      "Absolutely. We build AI-powered features such as intelligent chatbots, automated customer support, content generation tools, and recommendation engines, integrating modern AI APIs directly into your website or app to improve engagement and reduce manual workload.",
  },
  {
    question: "Do you provide support after the website or app is launched?",
    answer:
      "Yes. We offer post-launch support and maintenance packages covering bug fixes, security updates, performance monitoring, and feature enhancements, so your product keeps running smoothly long after the initial launch.",
  },
  {
    question: "Which e-commerce platforms do you work with?",
    answer:
      "We build custom e-commerce stores using modern frameworks like Next.js with headless commerce setups, as well as platforms such as Shopify and WooCommerce, depending on your budget, catalog size, and growth plans.",
  },
  {
    question: "How do I get started with a project?",
    answer:
      "Simply reach out through our contact page or book a free consultation. We'll discuss your goals, requirements, and budget, then put together a proposal with timelines and pricing so you can decide if we're the right fit.",
  },
  {
    question: "What makes Hubmicroo different from other agencies?",
    answer:
      "We combine senior development talent with modern technology (Next.js, React, AI integrations) and a transparent, communication-first process. You get a dedicated team that treats your project like a product — focused on performance, design quality, and long-term scalability, not just delivery.",
  },
];
